import { render, staticRenderFns } from "./SinglePageNameInfo.vue?vue&type=template&id=61dafcd6&"
import script from "./SinglePageNameInfo.vue?vue&type=script&lang=js&"
export * from "./SinglePageNameInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports